import { useState } from 'react';

import './GTN_Game.css';

const GTNGameComponent = ({players, playerNames}) => {
    const rNum = (num) => Math.floor(Math.random() * Math.floor(num) + 1);
    
    const [number, setNumber] = useState(rNum(100));
    
    const [highscore, setHighscore] = useState(10);
    const [highscorePlayer, setHighscorePlayer] = useState('None');
    const [playerScores, setPlayerScores] = useState([10, 10, 10, 10]);
    
    const [chances, setChances] = useState(10);
    
    const [playerGuesses, setPlayerGuesses] = useState([0, 0, 0, 0]);
    const [guesses, setGuesses] = useState([]);
    
    const [playerMessages, setPlayerMessages] = useState({});
    const [message, setMessage] = useState('');
    
    const resetGame = () => {
        setChances(10);
        setGuesses([]);
        setPlayerGuesses([0, 0, 0, 0]);
        setNumber(rNum(100));
        return true;
    };
    
    const setNewPlayerGuesses = (value, index) => {
        const newPlayerGuesses = [...playerGuesses];
        newPlayerGuesses[index] = value;
        setPlayerGuesses(newPlayerGuesses);
        return true;
    }
    
    const handleSubmit = () => {
        const newPlayerMessages = {}
        
        let cont = true;
        for (let i = 0; i < players; i++) {
            const playerGuess = playerGuesses[i];
            if (!playerGuess) {
                newPlayerMessages[i] = 'You must guess a number.';
                cont = false;
            } else if (playerGuess < 1 || playerGuess > 100) {
                newPlayerMessages[i] = 'Your number must be 1-100';
                cont = false;
            } else if (guesses.includes(playerGuess)) {
                newPlayerMessages[i] = 'Your number was already guessed.'
                cont = false;
            };
        };
        
        if (!cont) {
            setPlayerMessages(newPlayerMessages);
            return;
        }
        
        const newGuesses = [...guesses];
        for (let i = 0; i < playerGuesses.length; i++) {
            newGuesses.push(playerGuesses[i]);
        };
        setGuesses(newGuesses);
        
        let winner = false;
        let newMessage = '';
        for (let i = 0; i < players; i++) {
            const playerGuess = playerGuesses[i];
            if (parseInt(playerGuess) === number) {
                newPlayerMessages[i] = 'You guessed the number!';
                winner = true;
                newMessage += `${playerNames[i]}, `;
                
                if (chances < playerScores[i]) {
                    const newPlayerScores = [...playerScores];
                    newPlayerScores[i] = 10 - chances;
                    setPlayerScores(newPlayerScores);
                };
                
                if (chances < highscore) {
                    setHighscore(10 - chances);
                    setHighscorePlayer(playerNames[i]);
                };
            } else {
                if (playerGuess < number) {
                    newPlayerMessages[i] = 'The number is higher.';
                } else if (playerGuess > number) {
                    newPlayerMessages[i] = 'The number is lower.'
                };
            };
        };
        
        if (newMessage) {
            newMessage += 'guessed the correct number.'
            setMessage(newMessage);
        }
        
        setPlayerMessages(newPlayerMessages);
        if (winner) return resetGame();
        
        if (chances === 1) {
            setMessage('No one was able to guess the number :(');
            return resetGame();
        }
        
        setChances(chances - 1);
    };
    
    return (
        <div id='gtn-board-container'>
            <div id='gtn-board-playernames'>
                {playerNames.map((el, i) =>
                    <div key={i} className='gtn-board-playerinfo'>
                        <p style={{fontWeight: '600'}}><u>{el.toUpperCase()}</u></p>
                        <p>Best Score: {playerScores[i]}</p>
                    </div>
                )}
            </div>
            
            <div id='gtn-board-info-div'>
                <p style={{fontWeight: '600'}}>Highscore: {highscore} {highscore === 1 ? 'guess' : 'guesses'}</p>
                <p style={{fontWeight: '600'}}>Highscore Player: {highscorePlayer.toUpperCase()}</p>
                <p style={{fontWeight: '600'}}>Tries left this round: {chances}</p>
            </div>
            
            <p style={{color: 'red'}}>{message}</p>
            
            <div id='gtn-board-player-guess-input-div'>
                {playerNames.map((el, i) =>
                    <div key={i} className='gtn-board-player-guess-input-div'>
                        <p style={{fontWeight: '600'}}><u>{el.toUpperCase()}'s Guess</u></p>
                        <input className='gtn-board-player-guess-input'
                            type='number'
                            value={playerGuesses[i]}
                            onChange={(e) => setNewPlayerGuesses(e.target.value, i)}
                            min={1}
                            max={100}
                        />
                        {playerMessages[i] && <p className='gtn-board-player-message'>{playerMessages[i]}</p>}
                    </div>
                )}
            </div>
            
            <div id='gtn-board-guess-submit-div'>
                <button id='gtn-guess-submit-button'
                    onClick={handleSubmit}
                >Submit {players === 1 ? 'Guess' : 'Guesses'}</button>
            </div>
            
        </div>
    );
};

export default GTNGameComponent;
